import { render, staticRenderFns } from "./WeekdaySelector.vue?vue&type=template&id=2aa54a9b&"
import script from "./WeekdaySelector.vue?vue&type=script&lang=js&"
export * from "./WeekdaySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports